import builder from '../builder';
import CommonFileEmpty from '../../streamline-icons/light/common-file-empty.svg';

export default builder('IconCommonFileEmptyLight', CommonFileEmpty);
